import { faChevronDown, faChevronUp, faPrescriptionBottleMedical, faRefresh } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState } from "react";
import { Badge, Button, Card, Col, OverlayTrigger, Row, Tooltip } from "react-bootstrap";
import { EXPLAIN_SX_RX } from "../../../../amplify/api-gateway/write";
import { GenerateModuleHeroV2 } from "../../../common/GenerateModuleHeroV2";
import { FakeLoadingBar } from "../common/FakeLoadingBar";
import { LLMDashboardFeedbackBar } from "../common/LLMDashboardFeedbackBar";
import { LLMDashboardUpdated } from "../common/LLMDashboardUpdated";
import { SectionSxRxButton } from "./SectionSxRxButton";
import { SectionSxRxDetails } from "./SectionSxRxDetails";
import { isSectionUnread } from "../utils";

export const SectionSxRx = ({
    isLoading,
    data,
    tenant,
    sxRxActive,
    setSxRxActive,
    patientVisit,
    feedbacks,
    setFeedbacks,
    statuses,
    setRegenerateTarget,
    setShowContextMenu,
    handleShowScanMultiModal,
    unreadFileVersionMap = undefined,
    latestFileVersions = undefined,
    sectionToSetter = undefined,
    handleFileVersionChange = undefined,
    scoresData = undefined,
    scanMultiForCitations = undefined,
}: any) => {
    const [isExpanded, setIsExpanded] = useState(true);

    const sxTitles = [
        "Pain",
        "Dyspnea",
        "Nausea",
        "Constipation",
        "Appetite",
        "Psychosocial",
        "Activity",
    ];

    const sxTitleToSection: { [key: string]: any } = {
        "Pain": "pain",
        "Dyspnea": "dyspnea",
        "Nausea": "nausea",
        "Constipation": "constipation",
        "Appetite": "appetite",
        "Psychosocial": "psychosocial",
        "Activity": "activity",
    };

    const textColors = [
        "blue-text",
        "green-text",
        "red-text",
        "purple-text",
        "orange-text",
    ];

    const scanMulti = scanMultiForCitations;

    if (!isLoading && !data) {
        return (
            <GenerateModuleHeroV2 type={EXPLAIN_SX_RX} setRegenerateTarget={setRegenerateTarget} setShowContextMenu={setShowContextMenu} />
        )
    }

    return (
        <Card className="mt-2">
            <FakeLoadingBar isActive={isLoading} maxDuration={30000} />
            <Card.Body>
                <Row>
                    <Col md={6}>
                        <div className="d-flex align-items-center">
                            <span className={`dashboard-actions-circle-small dashboard-actions-circle-blue me-2`}><FontAwesomeIcon icon={faPrescriptionBottleMedical} fixedWidth /></span><strong>Symptom Management</strong> {isSectionUnread(EXPLAIN_SX_RX, unreadFileVersionMap) && <Badge bg="info" className="ms-2">NEW</Badge>}
                        </div>
                    </Col>
                    <Col md={6} className="text-right">
                        <LLMDashboardUpdated patient={patientVisit} statuses={statuses} handleShowScanMultiModal={handleShowScanMultiModal} latestFileVersions={latestFileVersions} explainKey={"explain_sx_rx"} sectionToSetter={sectionToSetter} handleFileVersionChange={handleFileVersionChange} />
                        <OverlayTrigger
                            placement="bottom"
                            overlay={
                                <Tooltip>
                                    Refresh Section
                                </Tooltip>
                            }
                        >
                            <Button
                                variant="primary"
                                className="dashboard-round-btn"
                                onClick={(e: any) => {e.stopPropagation(); setRegenerateTarget(EXPLAIN_SX_RX); setShowContextMenu(true)}}
                                disabled={isLoading}
                            >
                                <FontAwesomeIcon icon={faRefresh} />
                            </Button>
                        </OverlayTrigger>
                        <LLMDashboardFeedbackBar patientVisit={patientVisit} feedbackTarget={"sx_rx"} feedbacks={feedbacks} setFeedbacks={setFeedbacks} />
                        <Button
                            variant="primary"
                            className="dashboard-round-btn"
                            onClick={(e: any) => {e.stopPropagation(); setIsExpanded(!isExpanded)}}
                        >
                            <FontAwesomeIcon icon={isExpanded ? faChevronUp : faChevronDown} />
                        </Button>
                    </Col>
                </Row>
                {
                    data && data["error"] ? (
                        <Row className="mt-2">
                            <Col md={6}>
                                Symptom Management was unable to be created. {data['error']}
                            </Col>
                        </Row>
                    ) : data ? (
                        <>
                            {isExpanded && (
                                <>
                                    {
                                        data && (
                                            <Row className="mt-2">
                                                <Col md={6}>
                                                    {
                                                        sxTitles.map((title: string, idx: number) => (
                                                            <SectionSxRxButton idx={idx} isLoading={false} active={sxRxActive} setActive={setSxRxActive} data={data[sxTitleToSection[title]]} title={title} color={textColors[idx % textColors.length]} scanMulti={scanMulti} />
                                                        ))
                                                    }
                                                </Col>
                                                <Col md={6}>
                                                    {
                                                        data[sxTitleToSection[sxTitles[sxRxActive]]] && (
                                                            <SectionSxRxDetails
                                                                data={data[sxTitleToSection[sxTitles[sxRxActive]]] ?? {}}
                                                                title={sxTitles[sxRxActive]}
                                                                scanMulti={scanMulti}
                                                            />
                                                        )
                                                    }
                                                </Col>
                                            </Row>
                                        )
                                    }
                                </>
                            )}
                        </>
                    ) : (
                        <></>
                    )
                }
            </Card.Body>
        </Card>
    );
};
